import { useEffect, useState, type FormEvent } from 'react';
import type { ConfiguracionDto } from '@reembolsables/shared';
import { copy } from '../../copy/es';
import { api, textoDeError } from '../../lib/api';
import { useSesion } from '../sesion';

/** Link validity in days (RF-06). Read-only users see the value; operators change it. */
export function ConfiguracionPage() {
  const { usuario } = useSesion();
  const c = copy.admin.configuracion;
  const [vigencia, setVigencia] = useState(15);
  const [historial, setHistorial] = useState(3);
  const [aviso, setAviso] = useState<{ ok: boolean; texto: string } | null>(null);
  const puedeEditar = usuario?.rol === 'operador';

  useEffect(() => {
    api<ConfiguracionDto>('/api/admin/configuracion')
      .then((d) => {
        setVigencia(d.vigenciaDias);
        setHistorial(d.historialMeses);
      })
      .catch((e) => setAviso({ ok: false, texto: textoDeError(e) }));
  }, []);

  async function guardar(e: FormEvent) {
    e.preventDefault();
    setAviso(null);
    try {
      await api('/api/admin/configuracion', {
        method: 'PUT',
        body: JSON.stringify({ vigenciaDias: vigencia, historialMeses: historial }),
      });
      setAviso({ ok: true, texto: c.guardado });
    } catch (err) {
      setAviso({ ok: false, texto: textoDeError(err) });
    }
  }

  return (
    <form onSubmit={guardar}>
      <h2>{c.titulo}</h2>
      <p className="sub">{c.vigenciaNota}</p>
      <div className="field" style={{ maxWidth: 220 }}>
        <label htmlFor="vigencia">{c.vigencia}</label>
        <input
          id="vigencia"
          type="number"
          min={1}
          max={90}
          value={vigencia}
          disabled={!puedeEditar}
          onChange={(e) => setVigencia(Number(e.target.value))}
        />
      </div>
      <p className="sub">{c.historialNota}</p>
      <div className="field" style={{ maxWidth: 220 }}>
        <label htmlFor="historial">{c.historial}</label>
        <input
          id="historial"
          type="number"
          min={1}
          max={24}
          value={historial}
          disabled={!puedeEditar}
          onChange={(e) => setHistorial(Number(e.target.value))}
        />
      </div>
      {aviso && (
        <div className={`ok-box ${aviso.ok ? '' : 'bad'}`} role={aviso.ok ? 'status' : 'alert'}>
          {aviso.texto}
        </div>
      )}
      {puedeEditar && <button className="cta">{c.guardar}</button>}
    </form>
  );
}
